import { RBAC_ACTIONS, RBAC_RESOURCES, buildRbacResource } from 'utils/rbac';

const page = ({ id, path, resource, action = RBAC_ACTIONS.SHOW }) => ({
    id,
    path,
    permissions: {
        resource: buildRbacResource(resource),
        action
    }
});

const pages = [
    page({ id: 'dashboard', path: '/dashboard', resource: RBAC_RESOURCES.DASHBOARD }),
    page({ id: 'assessments', path: '/assessments', resource: RBAC_RESOURCES.ASSESSMENTS }),
    page({ id: 'assessment-info', path: '/assessments/info', resource: RBAC_RESOURCES.ASSESSMENTS }),
    page({ id: 'candidates', path: '/candidates', resource: RBAC_RESOURCES.CANDIDATES }),
    page({ id: 'candidate-info', path: '/candidates/info', resource: RBAC_RESOURCES.CANDIDATES }),
    page({ id: 'candidate-invite', path: '/candidates/invite', resource: RBAC_RESOURCES.CANDIDATES, action: RBAC_ACTIONS.INVITE }),
    page({ id: 'courses', path: '/courses', resource: RBAC_RESOURCES.COURSES }),
    page({ id: 'course-create', path: '/courses/new', resource: RBAC_RESOURCES.COURSES, action: RBAC_ACTIONS.CREATE }),
    page({ id: 'course-edit', path: '/courses/edit/:id', resource: RBAC_RESOURCES.COURSES, action: RBAC_ACTIONS.UPDATE }),
    page({
        id: 'course-continue-draft',
        path: '/courses/continue-draft/:id',
        resource: RBAC_RESOURCES.COURSES,
        action: RBAC_ACTIONS.UPDATE
    }),
    page({ id: 'course-view', path: '/courses/view/:id', resource: RBAC_RESOURCES.COURSES }),
    page({ id: 'analytics', path: '/analytics', resource: RBAC_RESOURCES.REPORTS }),
    page({ id: 'settings', path: '/settings', resource: RBAC_RESOURCES.SETTINGS })
];

export default pages;
